const PlusIcon = (props) => (
  <svg width="17" height="16" viewBox="0 0 17 16" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <path d="M7.8335 7.33325V3.33325H9.16683V7.33325H13.1668V8.66659H9.16683V12.6666H7.8335V8.66659H3.8335V7.33325H7.8335Z"/>
  </svg>
);

export default PlusIcon;
